import moment from 'moment';

export const monthNames = [
	'Ianuarie',
	'Februarie',
	'Martie',
	'Aprilie',
	'Mai',
	'Iunie',
	'Iulie',
	'August',
	'Septembrie',
	'Octombrie',
	'Noiembrie',
	'Decembrie'
];

export function getLastWeekFromDay(day) {
	const arrDays = [];

	for (let i = day - 13; i <= day; i++) {
		const current = moment().date(i);
		arrDays.push({ CreatedAt: current.toISOString() });
	}

	return arrDays;
}

export function twoWeeksAgoFromYesterday() {
	const dates = [];
	for (let i = 14; i >= 0; i--) {
		const date = moment()
			.subtract(i + 1, 'days')
			.toISOString();
		dates.push(date);
	}
	return dates;
}

export function getDaysInMonth(month, year) {
	const monthDate = moment(`${year}-${month}`, 'YYYY-MM');
	const daysInMonth = monthDate.daysInMonth();
	const arrDays = [];

	for (let i = 0; i < daysInMonth; i++) {
		const current = moment().date(i + 1);
		arrDays.push({ StudyDate: current.toISOString() });
	}

	return arrDays;
}

export function calculateSecondsPassed(startTime, currentTime) {
	if (currentTime > startTime) {
		throw new Error('Current time cannot be greater than the start time.');
	}
	return startTime - currentTime;
}

// Format countdown into MM:SS
export function formatSecondToMMSS(seconds) {
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;
	return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

export function prettyDate(date) {
	if (!date) {
		return '';
	}
	const newDate = new Date(date);
	const dd = String(newDate.getDate());
	const mm = String(newDate.getMonth()); // January is 0!
	const yyyy = newDate.getFullYear();

	const today = `${dd} ${monthNames[mm]} ${yyyy}`;
	return today;
}

export function prettyDateTime(date) {
	const newDate = new Date(date);
	const dd = String(newDate.getDate());
	const mm = String(newDate.getMonth()); // January is 0!
	const yyyy = newDate.getFullYear();
	const hours = String(newDate.getHours()).padStart(2, '0'); // adds a leading zero if necessary
	const minutes = String(newDate.getMinutes()).padStart(2, '0'); // adds a leading zero if necessary

	const today = `${dd} ${monthNames[mm]} ${yyyy} ${hours}:${minutes}`;
	return today;
}

export function agoDate(date) {
	const from = moment(date);

	const hours = moment().diff(from, 'hours');
	if (hours > 24) {
		const years = Number.parseInt(hours / 8760, 10);
		if (years > 0) {
			if (years === 1) {
				return 'acum 1 an ';
			}
			return `acum ${years} ani  `;
		}
		const months = Number.parseInt(hours / 730, 10);

		if (months > 0) {
			if (months === 1) {
				return 'acum 1 lună ';
			}
			return `acum ${months} luni  `;
		}
		const weeks = Number.parseInt(hours / 168, 10);
		if (weeks > 0) {
			if (weeks === 1) {
				return 'acum 1 saptămână ';
			}
			return `acum ${weeks} saptămâni `;
		}

		const days = Number.parseInt(hours / 24, 10);
		if (days === 1) {
			return 'acum 1 zi ';
		}
		return `acum ${days} zile `;
	}

	if (hours > 0) {
		if (hours === 1) {
			return 'acum 1 oră ';
		}
		return `acum ${hours} ore `;
	}

	const minutes = moment().diff(from, 'minutes');
	if (minutes > 0) {
		if (minutes === 1) {
			return 'acum 1 minut ';
		}
		return `acum ${minutes} minute `;
	}

	const seconds = moment().diff(from, 'seconds');
	if (seconds >= 0) {
		return 'acum 1 minut ';
	}

	return date;
}

export function updateCountdown(countDownDate, refreshCountDown) {
	return setInterval(() => {
		const now = new Date().getTime();
		const timeleft = countDownDate.getTime() - now;
		const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
		const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

		if (days > 0) {
			let timeString = '';
			if (days > 1) {
				timeString = `${days}:`;
			} else {
				timeString = `${days}:`;
			}
			const el = document.getElementById('days');
			if (el !== null) {
				document.getElementById('days').innerHTML = timeString;
			}
		}

		if (hours > 0) {
			let timeString = '';
			if (hours > 9) {
				timeString += `${hours}:`;
			} else {
				timeString += `0${hours}:`;
			}
			const el = document.getElementById('hours');
			if (el !== null) {
				el.innerHTML = timeString;
			}
		}

		if (minutes > 0) {
			let timeString = '';
			if (minutes > 9) {
				timeString += `${minutes}:`;
			} else {
				timeString += `0${minutes}:`;
			}
			const el = document.getElementById('mins');
			if (el !== null) {
				el.innerHTML = timeString;
			}
		}

		if (seconds > 0) {
			let timeString = '';
			if (seconds > 9) {
				timeString += `${seconds}`;
			} else {
				timeString += `0${seconds}`;
			}
			const el = document.getElementById('secs');
			if (el !== null) {
				el.innerHTML = timeString;
			}
		}

		if (timeleft < 0) {
			clearInterval(refreshCountDown);
			document.getElementById('days').innerHTML = '';
			document.getElementById('hours').innerHTML = '';
			document.getElementById('mins').innerHTML = '';
			document.getElementById('secs').innerHTML = '';
			document.getElementById('limitMessage').innerHTML =
				'Timpul s-a scurs, esti pregatit sa o iei de la inceput.';
		}
	}, 1000);
}

export function daysLeftFromDate(targetDate) {
	// Parse the target date string to a Date object
	const targetDateTime = new Date(targetDate).getTime();
	// Get the current date and time
	const now = new Date().getTime();
	// Calculate the time difference in milliseconds between the target date and now
	const timeDiff = targetDateTime - now;
	// Convert milliseconds to days
	const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

	return daysLeft;
}
